import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import FooterContainer from '../../../components/footer-container/footer-container.component';
import MainService from '../../../services/main-service';
import useScreenSmall from '../../../hooks/use-screen-small';
import { NODE_ENV_PRODUCTION } from '../../../constants/system/node-envs';

const Footer: ReactMemoComponent = React.memo((): ReactElement => {
  const isSmallScreen: boolean = useScreenSmall();
  const isEditMode: boolean = useSelector(({ controls }: Reducers): boolean => controls.isEditMode);

  const isIntercomEnabled: boolean = MainService.NODE_ENV === NODE_ENV_PRODUCTION;
  const intercomAppId: string | undefined = MainService.INTERCOM_APP_ID;
  const withIntercomBlock: boolean = !!intercomAppId && isIntercomEnabled && !isEditMode;
  const isInvisible: boolean = !withIntercomBlock;

  return (
    <FooterContainer isInvisible={isInvisible} withBottomOffset={isSmallScreen} />
  );
});

export default Footer;
